export enum ExtendedInspectionDimensionSrcCollection {
  INSPECTION_DIMENSIONS = 'inspectionDimensions',
  OPERATION_DIMENSIONS = 'operationDimensions', // SHM_LNH_DIMENSION
  HANDLING_UNIT_DIMENSIONS = 'handlingUnitDimensions', // SHM_HANDLING_UNIT
  INSPECTION_DIMENSIONS_HISTORY = 'inspectionDimensionHistory',
}
